import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SDAngularJsonAPIRequestService } from './services/sd-angular-jsonapi-request.service';
import { EntityManager } from './services/sd-angular-jsonapi-entity-manager';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SdAngularJsonAPIMediaHeaderInterceptor } from './services/sd-angular-jsonapi-media-header-interceptor';

@NgModule(
	{
		imports: [
			CommonModule
		]
	})
export class SDAngularJsonAPIModule {
	public static forRoot (): ModuleWithProviders {
		return {
			ngModule: SDAngularJsonAPIModule,
			providers: [
				SDAngularJsonAPIRequestService,
				EntityManager,
				{
					provide: HTTP_INTERCEPTORS,
					useClass: SdAngularJsonAPIMediaHeaderInterceptor,
					multi: true
				}
			]
		};
	}
}
